var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "job-listing--item-head" },
    [
      _c(
        "div",
        { staticClass: "job-listing--item-head-line1" },
        [
          _c("Messages", {
            attrs: { job: _vm.job },
            on: { close: _vm.closeMessages }
          }),
          _vm._v(" "),
          _c("Appointments", {
            attrs: { job: _vm.job },
            on: {
              close: function($event) {
                return _vm.$emit("closeAppointments")
              }
            }
          }),
          _vm._v(" "),
          _c("Favorites", {
            attrs: { job: _vm.job },
            on: {
              load: function($event) {
                return _vm.$emit("loadFavorites")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "links-container" }, [
        _c(
          "span",
          { staticClass: "matches" },
          [
            _vm.job.matches > 0
              ? [
                  _vm.isQuestionnaireFinished
                    ? [
                        _vm.isPublished
                          ? _c(
                              "span",
                              { staticClass: "color-primary" },
                              [
                                _c("Icon", {
                                  attrs: { icon: "heart", color: "primary" }
                                }),
                                _vm._v(
                                  " " + _vm._s(_vm.matches) + "\n\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                          : _c(
                              "span",
                              [
                                _c("Icon", {
                                  attrs: { icon: "heart", color: "default" }
                                }),
                                _vm._v(
                                  " " + _vm._s(_vm.matches) + "\n\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                      ]
                    : _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showResultsUnpublished.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        },
                        [
                          _c("Icon", {
                            attrs: { icon: "heart", color: "primary" }
                          }),
                          _vm._v(" " + _vm._s(_vm.matches) + "\n\t\t\t\t")
                        ],
                        1
                      )
                ]
              : _c(
                  "span",
                  [
                    _c("Icon", { attrs: { icon: "heart" } }),
                    _vm._v(" " + _vm._s(_vm.matches) + "\n\t\t\t")
                  ],
                  1
                )
          ],
          2
        ),
        _vm._v(" "),
        _vm.isQuestionnaireFinished
          ? _c(
              "a",
              {
                class: ["status", { published: _vm.isPublished }],
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.clickedPublishInfo.apply(null, arguments)
                  }
                }
              },
              [
                _c("Icon", {
                  attrs: { icon: _vm.isPublished ? "checkmark" : "close" }
                }),
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.isPublished
                        ? "Anonym veröffentlicht"
                        : "Noch nicht veröffentlicht"
                    ) +
                    "\n\t\t"
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showQuestionnaireHintPopUp
        ? _c(
            "PopUp",
            {
              attrs: {
                size: "lg",
                title: "Job Matches noch nicht sichtbar",
                "cancel-text": "Abbrechen",
                "ok-text": "Frag mich Skilly!"
              },
              on: {
                ok: _vm.openQuestionnaire,
                hidden: function($event) {
                  _vm.showQuestionnaireHintPopUp = false
                }
              }
            },
            [
              _c("p", [
                _vm._v(
                  "Um die Job Matches sehen zu können, benötigen wir noch ein paar mehr Infos von dir."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Skilly fragt dich gerne noch ein paar Sachen und sagt dir dann Bescheid, wenn du die Matches sehen\n\t\t\tkannst."
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.publish
        ? _c("PublishPopUp", {
            attrs: { job: _vm.job },
            on: {
              hidden: function($event) {
                _vm.publish = false
              },
              publish: _vm.onPublish
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.unpublish
        ? _c("UnpublishPopUp", {
            attrs: { job: _vm.job },
            on: {
              hidden: function($event) {
                _vm.unpublish = false
              },
              unpublish: _vm.onUnpublish
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }